import { StudentSkillStates } from '../../models/StudentSkillState';

export const applyOptimisticValues = (skillStates: StudentSkillStates[], instantValue: StudentSkillStates | null) => {
  return skillStates.map(sss => {
    if (instantValue && instantValue.id === sss.id) {
      return { ...sss, skillAssessment: instantValue.skillAssessment, skillSubstate: instantValue.skillSubstate };
    } else {
      return sss;
    }
  });
};
